<template>
    <div class="login-content">
        <div class="df">
            <el-card class="box-card">
                <el-form label-position="top" :rules="rules" status-icon label-width="80px" :model="formLabelAlign"
                    ref="formLabelAlign" size="small">
                    <el-form-item label="用户名" required="" prop="username">
                        <el-input v-model="formLabelAlign.username" placeholder="请输入用户名"></el-input>
                    </el-form-item>
                    <el-form-item label="密码" required="" prop="password">
                        <el-input v-model="formLabelAlign.password" placeholder="请输入密码" type="password"
                            autocomplete="off" show-password></el-input>
                    </el-form-item>
                    <el-form-item label="验证码" required="" prop="code">
                        <div style="display: flex;">
                            <el-input v-model="formLabelAlign.code" placeholder="请输入验证码"></el-input>
                            <img @click="getPicCode()" v-if="picUrl" :src="picUrl" alt=""
                                style="height: 33px; cursor: pointer; padding-left: 5px;">
                        </div>
                    </el-form-item>
                    <el-form-item style="display: flex;justify-content: center;padding-top: 25px;">
                        <el-button type="primary" @click="submitForm('formLabelAlign')"
                            style="width: 80px;padding: 0;">登录</el-button>
                        <el-button type="primary" @click="resetForm('formLabelAlign')"
                            style="width: 80px;padding: 0;">查</el-button>
                    </el-form-item>
                </el-form>
            </el-card>
        </div>
    </div>
</template>

<script>
    import {
        codeLogin,
        getPicCode,
        codeLoginCheck
    } from '@/api/login'
    export default {
        name: 'LoginPage',
        data() {
            return {
                picKey: '', // 将来请求传递的图形验证码唯一标识
                picUrl: '', // 存储请求渲染的图片地址
                totalSecond: 60, // 总秒数
                second: 60, // 当前秒数，开定时器对 second--
                timer: null, // 定时器 id
                mobile: '', // 手机号
                picCode: '', // 用户输入的图形验证码
                msgCode: '', // 短信验证码
                uuid: '',
                formLabelAlign: {
                    username: '',
                    password: '',
                    code: ''
                },
                rules: {
                    username: [{
                        required: true,
                        message: '用户名不能为空',
                        trigger: 'blur'
                    }],
                    password: [{
                        required: true,
                        message: '密码不能为空',
                        trigger: 'blur'
                    }],
                    code: [{
                        required: true,
                        message: '验证码不能为空',
                        trigger: 'blur'
                    }]
                }
            }
        },
        async created() {
            this.getPicCode()
        },
        methods: {
            async submitForm(formName) {
                var that = this;
                var valids = false;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        valids = true;
                    }
                });
                if (valids) {
                    const res = await codeLogin(this.formLabelAlign.username, this.formLabelAlign.password, this
                        .formLabelAlign.code, this.uuid, true)
                    if (res.status == 200) {
                        this.$message({
                            message: '登录成功',
                            type: 'success'
                        });
                        window.localStorage.setItem('rbToken', res.token);
                        setTimeout(function() {
                            that.$router.replace('/home')
                        }, 1000);
                    } else {
                        this.$message.error(res.message);
                    }
                }
            },
            async resetForm(formName) {
                var valids = false;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        valids = true;
                    }
                });
                if (valids) {
                    const res = await codeLoginCheck(this.formLabelAlign.username, this.formLabelAlign.password, this
                        .formLabelAlign.code, this.uuid, false)
                    if (res.status == 200) {
                        window.localStorage.setItem('rbToken', res.token);
                        this.$router.push('/mobile/oldStat');
                    } else {
                        this.$message.error(res.message);
                    }
                }
            },
            // 获取图形验证码
            async getPicCode() {
                const data = await getPicCode()
                this.picUrl = data.message // 存储地址
                this.uuid = data.uuid;
            }
        }
    }
</script>

<style lang="less" scoped>
    .container {
        padding: 49px 29px;

        .title {
            margin-bottom: 20px;

            h3 {
                font-size: 26px;
                font-weight: normal;
            }

            p {
                line-height: 40px;
                font-size: 14px;
                color: #b8b8b8;
            }
        }

        .form-item {
            border-bottom: 1px solid #f3f1f2;
            padding: 8px;
            margin-bottom: 14px;
            display: flex;
            align-items: center;

            .inp {
                display: block;
                border: none;
                outline: none;
                height: 32px;
                font-size: 14px;
                flex: 1;
            }

            img {
                width: 94px;
                height: 31px;
            }

            button {
                height: 31px;
                border: none;
                font-size: 13px;
                color: #cea26a;
                background-color: transparent;
                padding-right: 9px;
            }
        }

        .login-btn {
            width: 100%;
            height: 42px;
            margin-top: 39px;
            background: linear-gradient(90deg, #ecb53c, #ff9211);
            color: #fff;
            border-radius: 39px;
            box-shadow: 0 10px 20px 0 rgba(0, 0, 0, .1);
            letter-spacing: 2px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    .login-content {
        width: 100%;
        height: 100%
    }

    .df {
        margin: 8% auto;
        width: 80%;
        border: 2px solid #bbbbbb;
    }

    .df * {
        line-height: 32px
    }

    .df li {
        position: relative;
        display: inline;
        float: left
    }

    .df input {
        border: 1px solid #444444;
        width: 80px;
        height: 25px;
        line-height: 25px
    }

    .df img {
        width: 100px;
        height: 25px;
        line-height: 25px
    }

    .tit {
        display: block
    }

    .df ul {
        margin: 0 0 10px 10px
    }

    @media all and (min-width: 620px) {
        .df {
            width: 400px;
        }
    }
</style>
